module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2850.2ab99af6.png";